module.exports = __webpack_public_path__ + "img/about-hero.d55fe1cb.jpg";